export const arrayShuffle = (arr) => arr.sort(() => Math.random() - 0.5);

//Fisher-Yates implemenattion to shuffle array
export const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const getColorFromRedToGreenByPercentage = (value) => {
  const hue = Math.round(value);
  return ["hsl(", hue, ", 50%, 50%)"].join("");
};
